import { FieldsEnum } from 'app/shared/enums';

export const makeSelectorByFieldKey = (fields: Array<FieldsEnum>) =>
  fields.map((field) => `&[data-field-key="${field}"]`).join(', ');
